import transformerCreate from '../private/create';
import type ITourStatusDto_Api from './TourStatusDto.api';
import type ITourStatusDto from './TourStatusDto.if';
import type { ITourStatusDto_ComputedProps, ITourStatusDto_SourceProps } from './TourStatusDto.if';
import type { ITourStatusDto_Linkables } from './TourStatusDto.link';
import linkables from './TourStatusDto.link';
import mappings from './TourStatusDto.map';

/** 
 * @description pass in the data from the api response & build
   an object that responds to BaseDto & ITourStatusDto_SourceProps & ITourStatusDto_Linkables 
   & can be flattened back down to ITourStatusDto_Api 
*/
function generator(data: Partial<ITourStatusDto_Api>): ITourStatusDto {
    return transformerCreate<
        ITourStatusDto_Api,
        ITourStatusDto_SourceProps & ITourStatusDto_ComputedProps,
        ITourStatusDto_Linkables,
        'id'
    >('id', mappings, linkables(data), data);
}

export default generator;
